import { BaseDto } from './base.dto';
import { OrderDto } from './order.dto';
import { OrderStatusDto } from './orderStatus.dto';
import { UserDto } from './user.dto';

export class OrderStatusHistoryDto extends BaseDto {

  order?: OrderDto
  orderStatus?: OrderStatusDto;
  user?: UserDto;
  note?: string;
  createdDate?: Date;
  modifiedDate?: Date;
}
